import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import Logo from "../../../../assets/images/logo.png";
import useStores from "../../../../hooks/useStores";
import {
  correctorLink as fetchCorrectorLink,
  producerLink as fetchProducerLink,
} from "../../../../gateway/requests/CorrectorProducerRequests";
import { LogoImage, StyledBox, SubTitle, Title } from "../styles/HeaderStyles";

const DEFAULT_CORRECTOR = {
  id: "4",
  corretor_nome: "SULAMERICA",
  corretor_telefone: "(11) 3035-2222",
  ea: "73582",
  ev: "999999",
  aa: "35520",
  corretorLink: "sulamerica",
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { correctorAndProducerStore } = useStores();
  const { setCorrector, setProductor, setLoading } = correctorAndProducerStore;

  const lastRequestKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);

    if (!pathParts.length) return;

    const corretora = pathParts[0];
    const corretor = pathParts[1];

    const searchParams = new URLSearchParams();

    if (corretora) {
      searchParams.set("corretora", corretora);
    }

    if (corretor) {
      searchParams.set("corretor", corretor);
    }

    navigate(
      {
        pathname: "/",
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (location.pathname !== "/") return;

    const requestKey = location.search || "?";

    if (lastRequestKeyRef.current === requestKey) return;
    lastRequestKeyRef.current = requestKey;

    const fetchCorrectorAndProducer = async () => {
      const searchParams = new URLSearchParams(location.search);
      const corretoraParam = searchParams.get("corretora") ?? "sulamerica";
      const corretorParam = searchParams.get("corretor");

      setLoading(true);

      try {
        let currentCorrector = DEFAULT_CORRECTOR;

        const correctorResponse = await fetchCorrectorLink(corretoraParam);

        if (
          correctorResponse &&
          (correctorResponse.status === 200 || correctorResponse.status === 201)
        ) {
          currentCorrector = { ...correctorResponse.data };
          setCorrector(currentCorrector);
        } else {
          setCorrector(DEFAULT_CORRECTOR);
          toast.error(
            "Não foi possível recuperar os dados do corretor, tente mais tarde!"
          );
        }

        if (corretorParam) {
          const producerResponse = await fetchProducerLink(
            corretorParam,
            currentCorrector.ev
          );

          if (
            producerResponse &&
            (producerResponse.status === 200 || producerResponse.status === 201)
          ) {
            const producerData = Array.isArray(producerResponse.data)
              ? producerResponse.data[0]
              : undefined;

            if (producerData) {
              setProductor({ ...producerData });
            } else {
              toast.error(
                "Não foi possível recuperar os dados do produtor, tente mais tarde!"
              );
            }
          } else {
            toast.error(
              "Não foi possível recuperar os dados do produtor, tente mais tarde!"
            );
          }
        }
      } catch (error) {
        toast.error("Ocorreu um erro ao carregar os dados. Tente mais tarde.");
        setCorrector(DEFAULT_CORRECTOR);
      } finally {
        setLoading(false);
      }
    };

    fetchCorrectorAndProducer();
  }, [location.pathname, location.search, setCorrector, setProductor, setLoading]);

  return (
    <StyledBox id="inicio">
      <LogoImage src={Logo} alt="Logo da SulAmérica" />
      <Title>SulAmérica Odonto, planos com as melhores ofertas e benefícios.</Title>
      <SubTitle>Escolha o seu!</SubTitle>
    </StyledBox>
  );
};

export default Header;
